/** Geographic bounds of one humidity overlay version, as Google Maps wants them. */
export type BoundsLiteral = { east: number; north: number; south: number; west: number };

/**
 * Narrows an overlay version to a `LatLngBoundsLiteral`.
 *
 * Versions come out of `parseMaps` carrying the whole serialized map (`file`, `id`,
 * `created`, `referenceItems`, …) alongside the four coordinates, and
 * `google.maps.Map.fitBounds` rejects a literal with any unknown property
 * (`InvalidValueError: not a LatLngBounds or LatLngBoundsLiteral: unknown property file`),
 * which leaves the map with no center/zoom and therefore blank. So only the four
 * coordinates may be forwarded.
 */
export const toBoundsLiteral = (version?: Partial<BoundsLiteral> | null): BoundsLiteral | undefined => {
    if (!version) return undefined;
    const { north, south, east, west } = version;
    // 0 is a legitimate coordinate, so this checks for finite numbers rather than truthiness.
    if (![north, south, east, west].every((value) => typeof value === 'number' && Number.isFinite(value))) {
        return undefined;
    }
    return { north, south, east, west } as BoundsLiteral;
};
